import React, {Fragment, useState, useEffect, useMemo, useContext} from "react";
import "./MatchesList.less";
import MatchItem from "./MatchItem";
import {API_KEY} from "../../default_informations/api_key";
import Loader from "../Loader";
import {Context} from "../Context/MatchesContext";
import ModalMatch from "../ModalMatch";
import {TransitionGroup, CSSTransition} from "react-transition-group";

function MatchesList() {
    const apiKey = API_KEY;
    const [proMatches, setProMatches] = useState([]);
    const [matchesList, setMatchesList] = useState([]);
    const {searchTeam, sidebarLeagueID, showModal, modalMatchInfo} = useContext(Context);

    useMemo(() => {
        fetch(`https://api.opendota.com/api/proMatches?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => {
                let match_count = 0;
                let matches_arr = result.filter(item => {
                    //console.log(`${item.dire_name} - ${item.radiant_name}`);

                    if (Boolean(item.dire_team_id) && Boolean(item.radiant_team_id && Boolean(item.dire_name) && Boolean(item.radiant_name)) && (match_count < 24)) {
                        match_count++;
                        return item;
                    }
                    return null;
                });
                setProMatches(matches_arr);
            })
    }, [apiKey]);

    useEffect(() => {
        let arr = [...proMatches];
        let matches_arr = arr.filter(item => {
            if ( (item.dire_name.toLowerCase().substr(0, searchTeam.length) === searchTeam) || (item.radiant_name.toLowerCase().substr(0, searchTeam.length) === searchTeam) ) {
                return item;
            }
            return null;
        });
        if (matches_arr.length === 0) matches_arr.push({
            match_id: 1,
            empty_text: 'Команд с таким названием нет'
        });
        setMatchesList(matches_arr);
    }, [searchTeam, proMatches]);

    useEffect(() => {
        let arr = [...proMatches];
        let matches_arr = arr.filter(item => {
            if (sidebarLeagueID === 'all') {
                return item;
            } else if (item.leagueid === sidebarLeagueID) {
                return item;
            }
            return null;
        });
        setMatchesList(matches_arr);
    }, [sidebarLeagueID, proMatches]);

    useEffect(() => {
        let arr = [];
        let unique_arr = [];
        if (matchesList.length) {
            matchesList.map(item => {
                if (!arr.includes(item.dire_team_id)) {
                    arr.push(item.dire_team_id);
                    unique_arr.push(item);
                }
                return null;
            });
        }
        //console.log(unique_arr);
    }, [matchesList]);

    return (
        <Fragment>
            {
                matchesList.length ? (
                    <TransitionGroup className="gg-main-tournaments all-tournaments" component="div">
                        {
                            matchesList.map(item => (
                                <CSSTransition key={item.match_id} timeout={500}>
                                    <MatchItem match={item} />
                                </CSSTransition>
                            ))
                        }
                        {showModal ? <CSSTransition timeout={300}><ModalMatch matchInfo={modalMatchInfo} /></CSSTransition> : null}
                    </TransitionGroup>
                ) : (
                    <Loader/>
                )
            }
        </Fragment>
    )
}

export default MatchesList;